import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents, typography }: ComposedTheme) => ({
  checkboxLabel: {
    fontFamily: formComponents.checkboxLabel.fontFamily,
    fontSize: formComponents.checkboxLabel.fontSize,
    fontWeight: formComponents.checkboxLabel.fontWeight,
    color: formComponents.checkboxLabel.color,
    display: formComponents.checkboxLabel.display,
    marginLeft: formComponents.checkboxLabel.marginLeft,
    alignItems: 'center',
    lineHeight: '16px',
    '&$dark': {
      color: formComponents.dark.color,
    },
    '& $toolTipIcon': {
      top: 1,
    },
  },
  checkboxLabelWrapper: {
    display: 'flex',
    height: 16,
  },
  dark: {},
  error: {},
  inline: {},
  inlineText: {
    display: 'inline-block',
    margin: 0,
    lineHeight: formComponents.label.lineHeight,
    fontSize: formComponents.optionalSpanFontSize,
    fontWeight: typography.fontWeightHeavy,
    whiteSpace: 'nowrap',
  },
  optional: {
    float: 'right',
    fontWeight: typography.fontWeight,
    textTransform: 'none',
  },
  optionalWithTooltip: {
    position: 'relative',
    top: 5,
  },
  root: {
    ...formComponents.label,
    '&$dark': {
      color: formComponents.dark.color,
    },
    '&$error': {
      '&$dark': {
        color: formComponents.dark.error.color,
      },
      color: formComponents.error.color,
    },
    '&$inline': {
      marginBottom: 0,
      marginRight: 8,
      '& $inlineText': {
        lineHeight: `${formComponents.input.height}px`,
      },
    },
    '&$warning$error': {
      '&$dark': {
        color: formComponents.dark.warning.color,
      },
      color: formComponents.warning.color,
    },
    lineHeight: 1,
  },
  toolTip: {
    fontSize: 12,
    fontWeight: typography.fontWeight,
  },
  toolTipIcon: {
    left: 4,
    position: 'relative',
    top: 3,
  },
  toolTipIconCheckbox: {
    left: 4,
    position: 'relative',
    top: 0,
  },
  warning: {},
});

export default createUseStyles(styles);
